import type { ISbStoryData } from '@storyblok/js'
import type { Page } from '@percent/cause-dashboard/storyblok/types/storyblok-components'
import type { GofundmeUserJourneysVariant } from '@percent/cause-dashboard/constants/gofundmeUserJourneys'
import { extractFirstBannersCarouselFromPageStory } from './extractBannersCarouselFromPageStory'
import {
  mapStoryblokBannerSlideToCarouselItem,
  type MarketplaceBannerCarouselItem
} from './mapStoryblokBannerSlideToBannerProps'

/**
 * Builds ordered carousel items from the first `banners_carousel` in the page story.
 * Invalid slides are skipped.
 */
export function buildMarketplaceBannerCarouselItemsFromStory(
  story: ISbStoryData<Page>,
  gfmVariant: GofundmeUserJourneysVariant | null = null
): MarketplaceBannerCarouselItem[] {
  const carousel = extractFirstBannersCarouselFromPageStory(story)
  const slides = carousel?.slides ?? []
  const visibleSlides = slides.filter(slide => !slide.experiment_variant || slide.experiment_variant === gfmVariant)
  const orderedSlides = [
    ...visibleSlides.filter(slide => slide.experiment_variant),
    ...visibleSlides.filter(slide => !slide.experiment_variant)
  ]
  return orderedSlides
    .map(mapStoryblokBannerSlideToCarouselItem)
    .filter((item): item is MarketplaceBannerCarouselItem => item !== null)
}
